import React, { Requireable, Validator } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CSSProperties } from '@material-ui/styles';
import { createStyles, Theme } from '@material-ui/core';
import _ from 'lodash';

// NK
import { options } from '../../infrastructure/theme';

interface NkCheckboxProps {
  name: string;
  value?: boolean;
  onChange: (propName?: string) => () => void;
  propName: string;
  label?: string;
  disabled?: boolean;
}

interface NkCheckboxState {}

class NkCheckbox extends React.Component<NkCheckboxProps, NkCheckboxState> {
  shouldComponentUpdate(nextProps: NkCheckboxProps) {
    return !_.isEqual(this.props, nextProps);
  }

  static propTypes: {
    name: Validator<string>;
    value: Requireable<boolean>;
    onChange: Validator<(propName?: string) => () => void>;
    propName: Validator<string>;
    label: Requireable<string>;
    disabled: Requireable<boolean>;
  };

  render() {
    return (
      <FormControlLabel
        control={
          <Checkbox
            name={this.props.name}
            id={this.props.name}
            checked={this.props.value}
            onChange={this.props.onChange(this.props.propName)}
            value={this.props.propName}
            color="primary"
            disabled={this.props.disabled}
          />
        }
        label={this.props.label}
      />
    );
  }
}

NkCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  propName: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default NkCheckbox;

const styles = (_theme: Theme) =>
  createStyles({
    label: {
      fontSize: options.readFontSize,
    },
  });

const useStyles = makeStyles(styles);

interface _NkCheckboxProps {
  label?: string;
  style?: CSSProperties | undefined;
  disabled?: boolean;
  value?: boolean;
  name: string;
  onChange(param: { target: { value: boolean } }): any;
}

export const _NkCheckbox = (props: _NkCheckboxProps) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      control={
        <Checkbox
          name={props.name}
          id={props.name}
          checked={props.value}
          color="primary"
          disabled={props.disabled}
          onChange={(e) =>
            props.onChange({ target: { value: e.target.checked } })
          }
          style={props.style}
        />
      }
      label={<span className={classes.label}>{props.label}</span>}
    />
  );
};

_NkCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};
